/**
 * Define file mixin
 *
 * @author minkyoung.park@emcast.com
 */
import httpService from "@/api/httpService.js";
import boardApi from "@/api/boardApi";
import { MDCTextField } from "@material/textfield";

import snackMessage from "@/plugins/snackMessage";
import axios from "axios";
import {mediaTypeConstants} from "@/utils/enum/MediaTypeConstants";

export const fileMixin = {
  data() {
    return {
      files: [],
      attachments: [],
      thumbnailUrl: require("@/images/blackBackground.jpg"),
      imageFiles: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
      videoFiles: [
        "video/mp4",
        "video/mp4v",
        "video/mpg4",
        "video/m4v",
        "video/quicktime",
        "video/avi",
        "video/wmv",
        "video/mkv",
        "video/mk3d",
        "video/mks",
        "video/webm"
      ],
      applicationFiles: [
        "application/pdf",
        "text/plain",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/hwp",
        "application/zip",
        "application/x-hwp",
        "application/zip-compressed",
        "application/x-zip-compressed"
      ]
    };
  },

  methods: {
    addTag(tag) {
      if (tag === "" || /^\s*$/.test(tag)) {
        this.tags = [];
        return;
      }

      const tagName = typeof tag === "string" ? { name: tag } : tag;
      this.form.tags.push(tagName);
      this.tags = [];

      this.$nextTick(() => {
        const inputElement = document.getElementById('tagInput');
        // const event = new Event('keyup');
        // inputElement.dispatchEvent(event);
        inputElement.value = null;
      });
    },

    allowImgExt() {
      return this.imageFiles;
    },

    allowExt() {
      return this.imageFiles.concat(this.videoFiles);
    },

    allowDocumentExt() {
      return this.imageFiles.concat(this.videoFiles, this.applicationFiles);
    },

    openFileUpload(type) {
      document.getElementById(type).click();
    },

    /**
     * 미션 첨부파일 업로드 메소드
     * @returns {boolean}
     */
    async uploadAttachmentFile() {
      let uploadedFiles = this.$refs.files.files;
      if (!uploadedFiles) return false;

      for (var i = 0; i < uploadedFiles.length; i++) {
        try {
          let returnFormData = this.inputTypeValidCheck(
            uploadedFiles[i],
            "ALL"
          );
          if(!returnFormData) {
            return false;
          }
          // 파일 개수 확인 후 10개 초과인 경우 스낵바 호출
          if (this.attachments.length >= mediaTypeConstants.LIMIT_TEN) {
            snackMessage(this.$t("3557"));
          } else {
            await this.uploadFileService(returnFormData, false);
          }
        } catch (err) {
          console.log("FAILURE!!", err);
        }
      }
    },

    /**
     * 질문 첨부파일 업로드 메소드
     * @returns {boolean}
     */
    async uploadChatFile() {
      let uploadedFiles = this.$refs.imageFiles.files[0];
      if (!uploadedFiles) {
        uploadedFiles = this.$refs.cameraFiles.files[0];
      }
      if(!this.mediaTypeValidCheck(uploadedFiles, "IMAGE")) {
        this.$hideLoading();
        return;
      }
      let formData = new FormData();
      formData.append("file", uploadedFiles);
      await this.uploadFileService(formData, true);
    },

    resetInputFiles() {
      let uploadFile = this.$refs.imageFiles ? this.$refs.imageFiles : document.getElementById("commentFileUpload");
      if(uploadFile) {
        uploadFile.value = "";
      }
    },

    uploadDocFile(evt) {
      this.$stickyLoading();
      const file = evt.target.files[0];
      if (
        !file ||
        !this.invalidCountFile() ||
        !this.validateSizeInput(file.size) || !this.ValidateExtensionType(file, 'ALL')
      ) {
        this.$hideLoading();
        return;
      }
      boardApi
        .upload(file)
        .then(response => {
          this.$hideLoading();
          this.form.contents.files.push(response.data.data[0]);
          let saveType = mediaTypeConstants.ATTACHED_SAVE_TYPE;

          let index = this.form.contents.files.indexOf(response.data.data[0]);
          if (index !== -1) {
            this.form.contents.files[index].saveType = saveType;
          }
        })
        .catch(err => {
          this.$hideLoading();
          if (err.meta.errCode === 1104) {
            snackMessage(this.$t("3462"));
          }
        });
    },

    async uploadContentsFile(evt) {
      this.$stickyLoading();
      if (
        !this.mediaTypeValidCheck(evt.target.files[0], "MEDIA") ||
        !this.invalidCountImg()
      ) {
        this.$hideLoading();
        return;
      }

      await boardApi
        .upload(evt.target.files[0])
        .then(response => {
          this.$hideLoading();
          this.form.contents.files.push(response.data.data[0]);
          let saveType = mediaTypeConstants.MEDIA_SAVE_TYPE;
          let index = this.form.contents.files.indexOf(response.data.data[0]);
          if (index !== -1) {
            this.form.contents.files[index].saveType = saveType;
          }
          this.resetInputFiles();
        })
        .catch(err => {
          this.$hideLoading();
          console.error('err => ', err)
        });
    },

    /**
     * 카메라/앨범 사진 동영상 업로드 메소드
     * @param evt 이벤트
     */
    uploadFile(evt) {
      this.$stickyLoading();
      if (
        !this.mediaTypeValidCheck(evt.target.files[0], "MEDIA") ||
        (this.isComment && !this.invalidCountImg())
      ) {
        this.$hideLoading();
        return;
      }

      boardApi
        .upload(evt.target.files[0])
        .then(response => {
          this.$hideLoading();
          if (this.isComment) {
            this.form.images.push(response.data.data[0]);
          } else {
            this.form.image = response.data.data[0];
          }
          this.resetInputFiles();
        })
        .catch(err => {
          this.$hideLoading();
          console.error("err", err);
        });
    },

    ValidateExtensionType(file, type) {
      switch (type) {
        case "ALL":
          if (!this.allowDocumentExt().includes(file.type) && !file.name.indexOf(".hwp")) {
            snackMessage(this.$t("3462"));
            return false;
          } else {
            return true;
          }
        case "IMAGE":
          if (!this.allowImgExt().includes(file.type)) {
            snackMessage(this.$t("3462"));
            return false;
          } else {
            return true;
          }

        case "MEDIA":
          if (!this.allowExt().includes(file.type)) {
            snackMessage(this.$t("3462"));
            return false;
          } else {
            return true;
          }
        default:
          return false;
      }
    },

    getType(contentType) {
      if (contentType) {
        return contentType.split("/")[0];
      }
    },

    getByte(size) {
      return Math.floor(size / 1024 ** 2);
    },

    validateSizeInput(input) {
      if (this.getByte(input) > 900) {
        snackMessage(this.$t("3556"));
        return false;
      } else {
        return true;
      }
    },

    /**
     * httpServie 파일 업로드 메소드
     *
     * @param fileData
     * @param {Boolean} singleFileCheck 단일, 다중 파일값 체크
     */
    async uploadFileService(fileData, singleFileCheck) {
      this.$stickyLoading();

      await httpService
        .upload(fileData)
        .then(response => {
          this.$hideLoading();
          if (singleFileCheck === true) {
            this.attachments = response.data.data;
            localStorage.setItem(
              "cameraFile",
              JSON.stringify(this.attachments)
            );
            this.resetInputFiles();
          } else {
            this.attachments = this.attachments.concat(response.data.data);
            this.resetInputFiles();
          }
        })
        .catch(err => {
          this.$hideLoading();
          console.log("FAILURE!!", err);
          if (err.meta.errCode === 1104) {
            snackMessage(this.$t("3462"));
          }
        });
    },

    uploadEditorFile(file, Editor, cursorLocation, resetUploader) {
      if (!this.mediaTypeValidCheck(file, "IMAGE")) {
        this.$hideLoading();
        return;
      }

      if(this.form.contents.editorImages.length >= mediaTypeConstants.LIMIT_TWENTY) {
        snackMessage(this.$t('3754'));
        return false;
      }

      this.$stickyLoading();
      boardApi.upload(file)
          .then(response => {
            this.$hideLoading();
            const responseData = response.data.data[0];
            this.form.contents.editorImages.push(responseData);
            Editor.insertEmbed(cursorLocation, "image", responseData.resourceUri);
            resetUploader();
          })
          .catch(err => {
            this.$hideLoading();
            console.log("FAILURE!!", err);
          });
    },

    removeEditorFile(img) {
      if (this.$_isMatchImgUrl(this.form.contents.body, img)) {
        return;
      }
      this.form.contents.editorImages = _.reject(this.form.contents.editorImages, (item) => item.resourceUri === img);
    },

    $_isMatchImgUrl: function(contents, imgUrl) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(contents, "text/html");
      const imageElements = Array.from(doc.querySelectorAll('img'));

      return imageElements.filter(e => e.src === imgUrl).length > 0;
    },

    /**
     * 업로드 파일 타입/사이즈 체크 메소드
     * @param {object} file 업로드 파일 오브젝트
     * @param {String} type 업로드 파일 익스텐션 타입
     * @returns {FormData|boolean}
     */
    inputTypeValidCheck(file, type) {
      if (file.type === "" && file.name.split(".").pop() !== "hwp") {
        return snackMessage(this.$t("3462"));
      }
      let formData = new FormData();
      let fileSize = file.size
      let returnType = this.ValidateExtensionType(file, type);
      let returnSize = this.validateSizeInput(fileSize);

      if (returnType === true && returnSize === true) {
        formData.append("file", file);
        formData.append("isUnzip", false);
        let saveType = mediaTypeConstants.MEDIA_SAVE_TYPE;

        formData.append("saveType", JSON.stringify(saveType));
        return formData;
      } else {
        if (returnType === false) {
          snackMessage(this.$t("3178"));
        }
        return false;
      }
    },

    /**
     * 미디어 파일 유효성 체크 메소드
     * @param {Object} file 미디어 파일 객체
     * @param {String} type 미디어 파일 익스텐션 타입
     * @returns {boolean}
     */
    mediaTypeValidCheck(file, type) {
      if (!file) return false;
      if (!this.ValidateExtensionType(file, type)) return false;
      return this.validateSizeInput(file.size);
    },

    // 파일 강제 다운로드(file force download)
    donwloadFile(fileInfo) {
      let fileName = fileInfo.file.id
        ? fileInfo.file.originalName
        : fileInfo.split("/").pop();
      let resourceUri = fileInfo.file.id ? fileInfo.file.resourceUri : fileInfo;

      httpService
        .fileDownload(resourceUri)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("error occured");
        });
    },

    donwloadAttachment(attachment) {
      let fileName = attachment.id
        ? attachment.originalName
        : attachment.split("/").pop();
      let resourceUri = attachment.id ? attachment.resourceUri : attachment;
      httpService
        .fileDownload(resourceUri)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("error occured");
        });
    },


    //Updated By Jungnam.lee@emcast.com 2022-07-04 Download File Name to Orginal File Name
    downloadFile(url, label, contentType) {
      axios.get(url, {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {type: contentType})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = label
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
    },

    /**
     * 체크리스트 질문 타입별 공통 메소드
     */
    deleteFileIndex(index) {
      this.attachments.splice(index, 1);
    },

    removeImage() {
      this.form.image = null;
    },

    /**
     * 이미지/카메라 전체 개수 카운트 메소드
     * @returns {boolean}
     */
    invalidCountImg() {
      if(this.form) {
        if(this.form.contents) {
          let imageDataList = _.filter(this.form.contents.files, file => {
            return file.saveType.value === mediaTypeConstants.MEDIA_SAVE_TYPE.value
          })
          if(imageDataList.length >= mediaTypeConstants.LIMIT_FIVE) {
            snackMessage(this.$t("3149"));
            return false;
          }
        } else {
          if (this.form.images.length >= mediaTypeConstants.LIMIT_FIVE) {
            snackMessage(this.$t("3149"));
            return false;
          }
        }
      } else {
        if(this.replyImg.length >= mediaTypeConstants.LIMIT_FIVE) {
          snackMessage(this.$t("3149"));
          return false;
        }
      }
      return true;
    },

    invalidCountFile() {
      let fileDataList = _.filter(this.form.contents.files, file => {
        return file.saveType.value === mediaTypeConstants.ATTACHED_SAVE_TYPE.value
      })
      if(fileDataList.length >= mediaTypeConstants.LIMIT_FIVE) {
        snackMessage(this.$t("3461"));
        return false;
      }
      return true;
    },

    toggleDocument() {
      this.documentshow = !this.documentshow;
      this.form.comment = "";
      this.filterTextArea();
    },

    listFilter(str) {
      // let strTrimmed = str.replace(/^\s+/, "");
      // let replacedStr = strTrimmed;
      // let strRemoveBrTag = replacedStr.replace(/<\/?[^>]+>/gi, " ");
      // let strRemoveImgTags = ;
      // return strRemoveImgTags;
      return str.replace(/<img[^>]*>/gi, "").replace(/(\r\n|\n|\r)/gm, "");
    },

    filterTextArea() {
      const newText = new MDCTextField(
        document.querySelector(".mdc-text-field_answer" + this.numberValue)
      );
      setTimeout(() => {
        const textField = new MDCTextField(
          document.querySelector(".answer-text-area" + this.numberValue)
        );
      }, 300);
    },

    /**
     * 비디오 플레이어 옵션 메소드
     *
     * @param {object} img 미디어 데이터 오브젝트
     * @param height 디폴트 매개변수 미디어 높이
     * @param width 디폴트 매개변수 미디어 넓이
     * @returns {{playbackRates: number[], sources: [{src: (null|*), type}], width: (*|string), language: string, muted: boolean, poster: *, height: (*|string)}}
     */
    getPlayerOption(img, height, width) {
      return {
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri
          }
        ],
        height: height ? height : "100%",
        width: width ? width : "100%",
        poster: img.subFileResourceUri[0]
          ? img.subFileResourceUri[0]
          : this.thumbnailUrl
      };
    },

    // mission allow file ext
    getSpecificAllowExt() {
      return [...this.imageFiles, "video/mp4", "video/mov", ...this.applicationFiles];
    },
  }
};
